import React from "react";

export default function Banner({ title = "" }) {
  return (
    <section class="ud-page-banner">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="ud-banner-content">
              <h1>{title}</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
